import { useQuery } from '@tanstack/react-query';
import { IFiltersByDependency } from 'components/filter/models/TableFilterModels';
import {
	fetchByFiltersDependency,
	fetchByFiltersDependencyFromExternalAPI,
} from 'services/api/requests/filters/filters';

export const useGetFiltersByDependency = (variables: IFiltersByDependency) => {
	const {
		column,
		search,
		size,
		page,
		module,
		getFromExternalAPI = false,
		editable = false,
		...others
	} = variables;
	return useQuery(
		[`${module}-list-dependency`, variables],
		() => {
			const requestBody = {
				column_name: column,
				search,
				size,
				page,
				...others,
			};

			return getFromExternalAPI
				? fetchByFiltersDependencyFromExternalAPI(requestBody)
				: fetchByFiltersDependency(requestBody, module, editable);
		},

		{
			onError: error => {
				console.log('error', error);
			},
			refetchOnWindowFocus: false,
			retry: false,
			enabled: !!variables.module,
			// cacheTime: 0, (desabilitando o cache, se necessário)
		}
	);
};
